import { Button, Col, Form } from 'react-bootstrap';
import React from 'react';
import { useForm } from 'react-hook-form';
import Amplify, { Auth } from 'aws-amplify';
import { AWS_CONFIG } from '../../../aws-config/aws-config';
import { genericHandlerError } from '../../../services/commonServices';
import cogoToast from 'cogo-toast';
Amplify.configure(AWS_CONFIG);

interface ProfileChangePasswordProps {
  onSuccess: Function;
}

function ProfileChangePassword({ onSuccess }: ProfileChangePasswordProps) {
  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors }
  } = useForm();

  const handleChangePassword = async (data: any) => {
    try {
      const currentUser = await Auth.currentAuthenticatedUser();
      await Auth.changePassword(currentUser, data.oldPassword, data.password);
      cogoToast.success('Password changed successfully.');
      onSuccess();
    } catch (error) {
      genericHandlerError(error);
    }
  };

  return (
    <Form onSubmit={handleSubmit(handleChangePassword)}>
      <Form.Row>
        <Form.Group as={Col} controlId="formPassword">
          <Form.Label>Password</Form.Label>
          <Form.Control
            type="password"
            placeholder="Old Password"
            {...register('oldPassword', {
              required: 'Old Password required'
            })}
          />
          {errors.password && (
            <Form.Control.Feedback type="invalid" className="display-block">
              {errors.password.message || 'Error'}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      </Form.Row>

      <Form.Row>
        <Form.Group as={Col} controlId="formPassword">
          <Form.Label>Password</Form.Label>
          <Form.Control
            type="password"
            placeholder="Password"
            {...register('password', {
              required: 'Password required',
              pattern: {
                value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\^$*.\[\]{}\(\)?\-“!@#%&/,><\’:;|_~`])\S{8,99}$/,
                message:
                  'The password must contain at least one lowercase alphabetical character, one uppercase alphabetical character, one special character and must be min 8 characters.'
              }
            })}
          />
          {errors.password && (
            <Form.Control.Feedback type="invalid" className="display-block">
              {errors.password.message || 'Error'}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      </Form.Row>

      <Form.Row>
        <Form.Group as={Col} controlId="formPhone">
          <Form.Label>Confirm Password</Form.Label>
          <Form.Control
            type="password"
            placeholder="ConfirmPassword"
            {...register('confirm_password', {
              required: 'Password must match',
              validate: value => value === getValues('password') || "Passwords don't match"
            })}
          />
          {errors.confirm_password && (
            <Form.Control.Feedback type="invalid" className="display-block">
              {errors.confirm_password.message || 'Error'}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      </Form.Row>

      <Form.Row className="py-3 m-0">
        <Button variant="dark" type="submit" className="create-account">
          Confirm
        </Button>
      </Form.Row>
    </Form>
  );
}

export default ProfileChangePassword;
